import { ref, watch } from 'vue';

/**
 * 页面标题动态覆盖（2026-10-17 用户需求：任务详情等隐藏页在顶部导航栏显示标题）。
 *
 * 机制：MainLayout header 显示 `路由 meta.title · 覆盖标题`；覆盖标题由插件页
 * 经 hostCtx.setPageTitle 上报（如 TaskDetailPage 加载任务后报任务名）。
 * 路由切换时 router.afterEach 统一清空——覆盖只在本页存活，离开即失效，
 * 页内异步加载晚于 afterEach 也安全（清了再设，顺序天然正确）。
 *
 * 浏览器标签标题同步（2026-11-03 用户需求：详情页打开后标签栏显示实体名）：
 * document.title = `覆盖标题 · 路由基准标题`，两者都空时回退 index.html 静态标题。
 * 基准标题由 main.js afterEach 按路由 meta.title 写入（routeTitle）；
 * 本 watch 在覆盖标题或基准标题变化时重算——覆盖晚于 afterEach 到达也自然覆盖。
 */
export const pageTitleOverride = ref('');
export const routeTitle = ref('');

// 回退：静态标题（首次加载时读一次；后续不再依赖 index.html 变化）
const FALLBACK_TITLE = (typeof document !== 'undefined' && document.title) || '数字化平台';

if (typeof document !== 'undefined') {
  watch(
    [pageTitleOverride, routeTitle],
    ([extra, base]) => {
      const o = String(extra || '').trim();
      const b = String(base || '').trim();
      document.title = o && b ? `${o} · ${b}` : (o || b || FALLBACK_TITLE);
    },
    { immediate: true },
  );
}

export function setPageTitle(title) {
  pageTitleOverride.value = String(title || '').trim();
}

export function clearPageTitle() {
  pageTitleOverride.value = '';
}

export function setRouteTitle(title) {
  routeTitle.value = String(title || '').trim();
}
